import { Button } from "@progress/kendo-react-all";
import { Typography } from "@progress/kendo-react-common";
import { chevronLeftIcon } from "@progress/kendo-svg-icons";
import { StatusPage } from "@excent-one/react/layout";
import { useRouter } from "@tanstack/react-router";

const NotFound = () => {
  const router = useRouter();

  return (
    <StatusPage code="404" title="Not Found">
      <Typography.p>
        The resource you're looking for was not found in the server. It may have
        been moved or it does not exist anymore.
      </Typography.p>
      <Typography.p>
        Please contact your IT Administrator if this is not expected.
      </Typography.p>
      <Button
        fillMode="outline"
        size="large"
        svgIcon={chevronLeftIcon}
        onClick={() => router.history.back()}
      >
        Back to previous page.
      </Button>
    </StatusPage>
  );
};

export default NotFound;
